import { Paper, Title, Text, Divider, Stack } from "@mantine/core";

function Blog20221229() {
  return (
    <Paper
      p="xl"
      radius="lg"
      withBorder
      shadow="sm"
      mt="lg"
      mx="auto"
      maw={700}
    >
      <Stack gap="md">
        <Title order={1}>12/29/2022: Why do we do things?</Title>
        <Divider />
        <Title order={2} size="h3">
          It's 12:53 AM.
        </Title>
        <Text>
          I'm taking ibuprofen following a couple of wisdom tooth extractions.
          Apparently I only had two wisdom teeth (#BuiltDifferent), so in a
          sense I guess I've won something from the genetic lottery. It's kind
          of weird that we even have wisdom teeth, but from what I recall (and
          because I'm too lazy to cite my sources at this point in the night),
          it's an evolutionary thing from when we used to eat more meat and chew
          our food more. We also chew less due to improved food processing
          techniques, which also led to more crooked teeth among certain
          populations over time. I guess Mastication is important. Anyways, the
          operation wasn't too bad besides not being able to eat for like 8
          hours before the operation and ~the day after if you get too lazy to
          prepare any soft foods to eat. I hear that everyone heals at a
          different rate, so your milage may vary. It's a little unfortunate
          that I did this during a break since I really want to eat solid food,
          but I guess it's better to do it sooner than later to avoid potential
          complications down the road. I had my biannual dentist cleaning like a
          week and a half ago and managed to book the consultation and operation
          over the last week and a half due to other people canceling their
          appointments, so I guess I got lucky with scheduling.
        </Text>
        <Text>
          I just rewrote my resume in LaTeX because I don't have Microsoft
          Office on my new laptop and I don't really like the transition from a
          one-time fee for Office into a subscription. I also don't know enough
          people who use the Office ecosystem that it justfies buying a family
          plan and splitting costs (👀 @ Netflix). Sure, a lot of people use
          Windows laptops, but there are alternatives to the Microsoft ecosystem
          that people can use. I ended up pretty much just copy-pastaing the
          resume, but LaTeX is kinda wonky, so it took a while to port it over.
          There was a lot of badness that I'm willing to overlook. It's still
          two-column, which is supposedly bad for ATS systems, but I think most
          application portals are just kind of stupid. Like we're asked to put
          in all the information that we already have on our resume, then they
          also expect their system to parse the resume in a comprehensible
          manner. So at this point I kind of gave up on ATS parsing and expect
          people to actually read the resume. Like if we put in this much time
          into writing a resume and making it look okay, I kind of expect people
          to at least look at it. I didn't make many more edits this time
          around, but one thing I learned is that it's sometimes hard to measure
          how much impact one feature or some contribution actually makes on the
          system, especially if it's part of some UX improvement initiative.
        </Text>
        <Text>
          I was actually in Taiwan from like mid-November to early December. I
          went back to visit some family since it's been a while since I've went
          back due to COVID and travel restrictions, but really I mostly went
          back to eat food. My one regret was not taking this time off and
          thinking that it's tenable to work and volunteer remotely with the
          time difference. It was okay to work in Taiwan time, but that meant I
          couldn't really go out and do stuff/grab food during the day. In the
          future I'll probably just plan to take the time off if I'm traveling.
          I didn't really get to eat as much as I would've liked to, which seems
          to be a problem people have when they get older, but the food I did
          eat was good. It's crazy how much cheaper food is in Taiwan. The cost
          of living is generally lower, but people also make less money there,
          so you know, tradeoffs exist.
        </Text>
        <Divider />
        <Text>
          During my sleep-addled transition to Taipei Standard Time, I felt like
          I had what was a quarter-life crisis (being generous 👀). It made me
          rethink what I thought about friends, work, and life.
        </Text>
        <Text>On friendship.</Text>
        <iframe
          style={{ borderRadius: "12px" }}
          src="https://open.spotify.com/embed/track/6iOQIQleZKnvWbPu9LZLnY?utm_source=generator&theme=0"
          width="100%"
          height="236"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
        <Text>
          What are friends? Are friends just people you talk to and hang out
          with? People you spend time with? In which case, when do people go
          from strangers, to acquaintances, to friends? Or when do people go
          from friends to acquaintances and back to strangers? I guess it's kind
          of hard to imagine that the people you interact with daily will
          change, but it almost always happens. Change is the natural state of
          things and I guess that's life. School was a target-rich environment
          for making friends, since there are always people around, but people
          come and go. Who you interact with and who you spend time with will
          change as you get older. This is true for almost everyone, minus like
          really tightly-knit small towns where no one ever moves out and people
          live to an old age. Although these communities are a little
          unfathomable to me in that there's this giant, diverse world out there
          and this small town is all they've known. It's not an invalid way to
          live, but definitely one of the more interesting situations in our
          hyperconnected society. I guess it's not really very rare if a large
          chunk of America lives in rural areas, at least by land mass. Maybe
          I'm a little pessimistic in that sense, since I feel like all
          relationships are situational and proximity-based and I feel like many
          friendships are doomed to end in neglect and decay until friends
          eventually become strangers. Common settings, interactions, and shared
          interests form the basis of relationships, but people and settings
          change over time. It's unlikely to meet someone who says that they
          haven't changed. Or they may deny it, but the change may have happened
          over time such that they don't recognize the small changes and don't
          even realize that they've changed significantly.
        </Text>
        <Text>
          I guess one of the problems I have is with how I view(ed) friendships.
          I viewed friendships as ephemeral so I didn't see the point in
          maintaining friendships. Like what is the point of maintaining
          relationships with people who are eventually going to leave? Or we lie
          to ourselves and claim that we're busy and have no time for this or
          that, when in reality all we have is time. It's impossible to keep all
          your friends over time, but it's likely that not all friendships are
          meant to decay into becoming strangers again. We all have friends that
          reach out and maintain the friendships, either by being proactive or
          spontaneous. I hope I can be more like that in the future. Maybe the
          key is that when you think of someone or something, reach out? I guess
          an open question is how to foster relationships and friendships. It is
          probably the wrong question to ask which relationships are worth
          maintaining, as it's too calculating and cold. Who are we and what is
          important to us? How do we maintain interest in other people and stay
          relevant to others such that we are more than just fairweather
          friends? What does it mean to live an interesting life?
        </Text>
        <Text>On work.</Text>
        <Text>
          Is work just a means to an end? Work is not life. Although it is
          likely undeniable that work is an aspect of life. Can you be friends
          with the people that you work with? Probably, but at the end of the
          day, we're all there for a our own reasons. There are a few things
          that can unite people, like it could be a vision, a dream, or maybe
          just a paycheck. The last one likely doesn't apply if you're already
          well-off, in which case you're probably working to give yourself a
          sense of meaning or a sense that you're contributing something to
          society. Who knows? Work supposedly gives people purpose or it's at
          least supposed to give some sense of it. Or at least that's been
          espoused as one of the pillars of a functioning society. Although some
          may argue that functioning is a generous way to describe our society,
          while others may also argue that "functioning" is on a spectrum and
          many things can be better or worse.
        </Text>
        <Text>
          "So be grateful for what you have," is what I hear from a member of my
          family, which is a little hard to accept. Like the idea that people
          have it worse than you, so you should be grateful for what you have.
          It's pretty much the "starving kids in Africa" argument. Their
          situation is recognizably worse, but is it enough to shut down
          conversations about how to make our own situations better? Do people
          not deserve to have nice things? What is the value of labor? Why are
          some forms of labor worth more than others? Is it the prerequisite
          knowledge that makes up the difference? The initial investment of time
          and money? How could people who didn't have the privilege of investing
          so much time and money be able to catch up or compete? Are they
          supposed to just be denied the opportunity to pursue their passions?
          Sure, some of the difference can be explained by hard work, but there
          is also a privilege associated with being able to work hard, like the
          other things happening in your life do not distracting you from
          whatever you're pursuing. Like you didn't have to care for sick or
          elderly family members. Or you didn't have to take care of younger
          siblings or start working early. People who prevail through
          problematic situations are strong, not because of their situations,
          but in spite of it. We live in a fundamentally inequitable society and
          instead of recognizing it, some people balk at the idea that
          inequality even exists in our Great society. Some opportunities
          afforded to some are nothing more than dreams or fairy tales for
          others. We do not live in a fair society.
        </Text>
        <Text>
          The contributions some people make in a society are also a little
          nebulous. Like a construction worker may be able to see the building
          that they helped build, but for other things like research, it's a
          little harder to see what the outcomes will be. It's a skill to be
          able to project where you are to set a course for where you want to be
          and recognize where you'll probably be. Some of it is managing
          expectations and some may argue that it's partly based on experience,
          partly based on speculation, and partly based on faith. It's a little
          suspect in the case of technology, like what kind of contribution does
          an app or feature make? What is the impact that something will make in
          the future? Then sometimes people can claim that you don't see the
          vision but it's a little hard to perceive something as mysterious and
          uncertain as the future. We will not be where we are in a week, a
          month, a year. The answers to important questions like, "What are we
          doing? Why are we doing this? Should we be doing something else?" will
          also change over time. Some things that we think might be necessary
          one week may be deemed unnecessary the next week. Perfect is the enemy
          of good. It doesn't make sense to spend too much time architecting a
          perfect system if it is uncertain whether it will exist in a few weeks
          or a few months. There may still be something to be gained in working
          with and learning from hypotheticals, but it likely does very little
          good to be bogged down in certain situations. No one can tell what the
          future will hold, but they can make an informed decision based on what
          they know about the past and present. Nothing stays still, everything
          in life moves on. So be okay with change.
        </Text>
        <Text>
          We are what we do. We aren't only what we do, but if we spend a large
          amount of time during the week working, say ~40 of our waking hours,
          we are, in a sense, at least partly what we do. I'm not talking about
          us being the sum of our productivity, as that's a rather bleak way of
          viewing things and sees workers as nothing more than units of work.
          But I mean that what we do for our jobs and the nature of our work has
          an impact on our lives. It gets incorporated into how we think about
          everything around us, like our thought processes, habits, and ideas.
          There are many other things in life that also have a significant
          impact, but the things that we do are undeniably a part of our
          identity and at least a snapshot of our values. Which begs the
          question, is what you're doing what you want to be doing? Is this
          where you want to be? Is this who you want to be? If you want to
          change, what does change look like and what do you need to do?
        </Text>
        <Text>On life.</Text>
        <Text>
          I likely need to exercise more. It makes no sense to work your entire
          life. It also doesn't make sense for the purpose of work to be
          retirement. What are we here to do? Does what we do matter? What is
          the impact of our work? The purpose of life is also probably not to
          become economically or financially viable. What does it mean to have
          lived a life? People come in and out of each other's lives, sharing
          stories and experiences. We probably should not only start living life
          when we are old and retired. So how do we live a life worth living?
          Well, I'm not sure, but I believe that everyone should be able to live
          a life worth living, not just those that were lucky enough to achieve
          financial freedom.
        </Text>
        <Text>
          Many things in life should not be tied to monetary amounts. Like the
          worth of a life, the cost of living, or the cost of healthcare. There
          will always be problems in society, but it seems more fruitful to
          start conversations off on matters that impact a lot of people rather
          than severely restrict the lives of a few. Like there are problems
          with universal healthcare and no system is perfect, but it seems like
          it's at least a better system than getting suffocated in a mountain of
          medical debt. Like a Woman's right to choose should not be brought
          into question by old men whose extent of knowledge on the female
          reproductive system is that it exists or that childbirth happens. It
          should be easy for people to vote on issues that matter to them.
          People and kids should not be going hungry, wanting mouths should be
          able to be fed; we live in excess for some and destitution for
          comparatively many. People deserve to be able to afford a place to
          live, a minimum wage should be a livable wage; not at the cost of
          working excessive hours or multiple jobs. Our agricultural industry
          heavily relies on migrant workers and the alienation of their needs,
          rights, or a path to citizenship has become a talking point.
          Consumerism goes hand in hand with anti-environmentalism and
          exploitation of the workers. I don't believe that people should own
          nothing, but many things can likely be made to be more sustainable so
          that we don't ruin the earth for generations to come.
        </Text>
        <Text>
          People deserve respect, our patience, and a chance. People talk about
          someone's personal responsibility to take care of themselves, but it
          is also our personal responsibility to help others in need. Some claim
          it is not the government that should help the people, but the people
          that should help the people. But are they? Do they? Will they? If not
          now, when?
        </Text>
        <Text>
          "Blessed are old people who plant trees knowing that they shall never
          sit in the shade of their foliage." It seems like many issues arise
          when the incentives are not aligned. Like why should people do
          something if it doesn't benefit them? Part of the problem is that our
          representatives are not always interested in the issues that matter to
          the people who need the representation the most. A rising tide lifts
          all boats; both big and small.
        </Text>
        <Text>
          It seems like we have been walking towards preventable disasters one
          step at a time, thinking it to be inevitable. We throw our hands up
          and say that it's not up to us to decide, that it's not our problem
          because it doesn't directly impact us. What do we do for the future?
          What will our kids, our grandkids, and future generations remember of
          us? We may not be important enough to exist in the history books, but
          the stories of our lives may be passed down. What actions can we take
          to make a lasting, positive impact for the future? How do we make life
          better for ourselves and others?
        </Text>
        <Divider />
        <Title order={1}>06/18/2023: A moment in time</Title>
        <Divider />
        <Title order={2} size="h3">
          It's 10:40 PM.
        </Title>
        <Text>
          I started this a few months ago and never found the motivation (read
          time to reflect on things) to finish it. Many things happened and many
          things didn't happen. Which is to say, as I have often said: life goes
          on, whether you want it to or not. I think something I could work on
          is to not work as hard. Like back in school and while I was growing
          up, I was taught that I should work hard if I want to suceed. I
          interpreted that as academic success and probably missed out on some
          things, but there's more to life than just academics. When I was
          volunteering, I thought of it as the number of people I helped or the
          number of tasks completed or the number of hours spent. Then when I
          started working, I interpreted it as the amount of work I got done, so
          the number of bugs I fixed and the number of features I implemented.
        </Text>
        <Text>
          It's a little stressful to work at a startup sometimes. Like it seems
          like we are always on crunch time and that everything is on fire. I
          felt some pressure from the uncertainty of it all. Maybe that is just
          the nature of working at a startup? How do you make an impact? How do
          you make a product that is marketable? How do you attract and retain
          customers? It can't just be something slick. It usually needs to have
          some bones to prop up the design. A friend told me that I don't get
          paid enough to worry as much as I do and they're probably correct.
          Although it's probably the case that no one gets paid enough to worry
          as much as they do. Or if they are, I'd be interested to hear a number
          👀. I'm also uncertain about whether my use of emojis is tied to the
          amount of underlying stress I'm feeling or if it's just something I
          picked up from work. Like using the 👀 emoji to mean I'm taking a look
          or that something is sus. And using like 😎 to mean that something is
          good or fine.
        </Text>
        <Text>
          We all try to do our best with who we are, where we're at, and what we
          have. "If you're tired and you're feeling around a 40% and you gave
          40% that day, you gave your 100% that day and should know that you did
          your best." - idk who said this, but it's good to quote things so you
          don't pass off knowledge as your own when it isn't. Proper attribution
          is important :^)
        </Text>
        <Text>
          Some people say that some stress is good for you, in similar terms to
          how eating some spicy food could be good for you. The problem is that
          while spicy food is generally avoidable, stress is a little harder to
          avoid. It might not be too much of a stretch to say that I've never
          felt fully relaxed in my life. There was always a feeling that there
          was something that I had to do, either right now or at some point in
          the future. Or like I was always waiting for some other shoe to drop,
          so I had to be prepared for when it did. I don't think I grew up with
          good coping mechanisms for stress. I think I alleviated stress by
          getting things done. Which, while productive, isn't very relaxing and
          does not go very far in terms of coming to terms with stressful
          situations. Getting things done mitigates some of the cause for the
          stress, but it does very little for your mental well-being or your
          ability to handle stress in your life. If your only mechanism for
          coping with stress is to work, but working is a cause of stress, you
          end up in a cycle of stress where you're very productive at the cost
          of your mental and physical well-being. (Or maybe it's my coping
          mechanism for a lack of control in my life. Like I cannot do anything
          about issues that exist so I put my efforts into something I can
          impact.) This is fundamentally unsustainable. It is like burning a
          candle on both ends. (Although in the metaphor, burning a single end
          of a candle was already problematic. Why should we permanently lose
          some of ourselves in order to get something done?) On the bright side,
          I found that yoga has been helpful with this. Since the point of the
          practice is to live in the moment, to push past and future stressors
          off and to focus on the here and now. Although this could also be the
          result of making time to focus on something other than work.
        </Text>
        <Text>
          I guess that's where my life is at. We will see what changes in a few
          months.
        </Text>
      </Stack>
    </Paper>
  );
}

export default Blog20221229;
